import * as yup from 'yup'

export const schema = yup.object({
  estado: yup.number().required('Estado é obrigatório'),
})
